var map = {
	"./b.json": [
		7421,
		421
	],
	"./check_green.json": [
		6023,
		23
	],
	"./check_green_star.json": [
		792,
		792
	],
	"./cross_red.json": [
		7,
		7
	],
	"./mail_notification.json": [
		8352,
		352
	],
	"./question_mark_yellow.json": [
		676,
		676
	],
	"./warning_yellow.json": [
		8036,
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3588;
module.exports = webpackAsyncContext;